import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [terminalKey, setTerminalKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Auto-login if secret key is provided via URL parameter
  useEffect(() => {
    const keyParam = searchParams.get('key');
    if (keyParam) {
      setLoading(true);
      login(keyParam).then((result) => {
        if (result.success) {
          navigate('/queue', { replace: true });
        } else {
          setError(result.error || 'Invalid terminal secret key');
          setLoading(false);
        }
      }).catch(() => {
        setError('An unexpected error occurred');
        setLoading(false);
      });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(terminalKey);

      if (result.success) {
        navigate('/queue');
      } else {
        setError(result.error || 'Invalid terminal secret key');
      }
    } catch (err) {
      setError('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="https://accesso.com/wp-content/uploads/2025/10/03-horizontal-full-color-1-e1761242891116.png" alt="accesso" className="login-logo" />
          <h1>Waiver Queue Terminal</h1>
          <p>Enter your terminal secret key</p>
        </div>

        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="terminalKey" className="input-label">
              Terminal Secret Key
            </label>
            <input
              id="terminalKey"
              type="password"
              value={terminalKey}
              onChange={(e) => setTerminalKey(e.target.value)}
              placeholder="tsk_..."
              required
              className="input"
              autoFocus
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="login-button"
          >
            {loading ? 'Connecting...' : 'Connect Terminal'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
